
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    mapCanvas: {
        height: '100%'
    },
    overlayView: {
        width: '50px',
        height: '30px',
        backgroundColor: '#FFF',
        border: '1px solid #CFCFCF',
        boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.39)',
        position: 'relative',
        textAlign: 'center',
        paddingTop: '10%',
        fontWeight: 'bold'
    },
    overlayViewHighlighted: {
        width: '50px',
        height: '30px',
        backgroundColor: '#00c8ff',
        color: '#FFF',
        border: '1px solid #00c8ff',
        boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.39)',
        position: 'relative',
        textAlign: 'center',
        paddingTop: '10%',
        fontWeight: 'bold'
    },
    fang: {
        position: 'absolute',
        width: '20px',
        height: '10px',
        bottom: '-10px',
        right: '15px',
        transform: 'rotate(180deg)'
    },
    fangShape: {
        fill: '#ffffff'
    },
    fangShapeHovered: {
        fill: '#00c8ff'
    },
    fangStroke: {
        stroke: '#CFCFCF',
        fill: 'transparent'
    },
    priceText: {
        pointerEvents: 'none'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/styles.js